export default "__VITE_ASSET__DUAdHf1w__"